import { useField } from "formik";
import React from "react";
import { Button } from "semantic-ui-react";

function PaidCheckBox(props) {
	const [{ value }, , { setValue }] = useField("paid");
	return (
		<Button
			{...props}
			onClick={(e) => {
				e.preventDefault();
				setValue(!value);
			}}
			icon={props.icon ?? "check"}
		/>
	);
}

export default PaidCheckBox;
